import {SalesCount} from '@platform/ui/SalesCount';
import {useIncreaseEmphasis} from '@platform/ui/useIncreaseEmphasis';
import {useMemo,useRef} from 'react';
import type {Snapshot} from '@platform/contracts/x';
import {money} from '@platform/client';
import {useCopy,useUi} from '@platform/ui/config';
import {PrizeAmount} from './PrizeAmount';
import {PeopleIcon} from '@platform/ui/PeopleIcon';
import {isCancelled,isFinished} from './roomFlow';

// Shared draw information; the sales count belongs beside the draw identity.
export function DrawPurchaseCount({state}:{state:Snapshot}){
 const t=useCopy();
 return <span className="draw-purchases" title={t('x.purchaseCountHelp')}><PeopleIcon/><SalesCount count={state.purchaseCount} identity={state.drawId} template={t('x.purchaseCount')}/></span>;
}

export function DrawSummary({state}:{state:Snapshot}){
 const t=useCopy(),ui=useUi(),prize=state.prizes.find(p=>p.id==='jackpot');
 const drawn=state.balls.at(-1)?.sequence??0,limit=state.x.jackpotBallLimit;
 const settled=isFinished(state),pending=state.x.jackpotCarryPending,awarded=prize?.awarded===true;
 const expired=!awarded&&drawn>=limit;
 const unavailable=isCancelled(state)||!awarded&&(settled||expired);
 const status=isCancelled(state)?t('room.cancelled'):awarded?t('x.jackpotSettled'):settled?t('x.jackpotCarried'):expired?t('room.jpExpired'):drawn?t('room.jpRemaining',{count:Math.max(0,limit-drawn)}):t('room.jpLimit',{count:limit});
 const formatter=useMemo(()=>new Intl.NumberFormat(ui.controls.prizeDisplayLocale,{style:'currency',currency:state.currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:0}),[ui.controls.prizeDisplayLocale,state.currency]);
 const remaining=Math.max(0,limit-drawn);
 const amount=prize?.amountMinor;
 const badge=useRef<HTMLDivElement>(null);
 useIncreaseEmphasis(badge,amount,state.drawId+state.currency,{disabled:unavailable||settled||awarded||pending,numberSelector:'.prize-amount',surfaceSelector:'.draw-jackpot-shine'});
 return <div ref={badge} className="draw-summary" data-jp-expired={expired} data-jp-settled={settled} data-jp-unavailable={unavailable} data-carry-pending={pending}>
  <span className="draw-jackpot-shine" aria-hidden="true"/>
  <div className="draw-jackpot" role="group" aria-disabled={unavailable} title={pending?t('x.jackpotPendingAmountHelp'):status} aria-label={`${t('prize.jackpot')} · ${amount===undefined?'—':money(amount,state.currency)} · ${pending?t('x.jackpotPendingAmountHelp'):status}`}>
   <span className="draw-jackpot-label">{t('prize.jackpot')}</span>
   {!settled&&!awarded&&remaining>0&&<span className="draw-jackpot-remaining" title={status} aria-label={status}>{remaining}</span>}
   {amount===undefined?<strong className="prize-amount">—</strong>:<PrizeAmount key={state.drawId+state.currency} minor={amount} formatter={formatter} settled={settled||expired||awarded}/>}
  </div>
 </div>;
}
